// MESSAGES
import BillingFormattedMessages from '../messages/billing/BillingFormattedMessages';

export const BillingRoutes = [
  {
    path: '/billing/invoices',
    label: BillingFormattedMessages.invoicesText,
  },
  {
    path: '/billing/payment-method',
    label: BillingFormattedMessages.paymentMethod,
  },
  {
    path: '/billing/summary',
    label: BillingFormattedMessages.billingsSummary,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/billing/new-customer-report',
    label: BillingFormattedMessages.newCustomerReport,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/billing/commission-report',
    label: BillingFormattedMessages.commissionReport,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/billing/expired-cards',
    label: BillingFormattedMessages.expiredCardsReport,
    accessLevel: '3',
    accessType: '3',
  },
  {
    path: '/billing/purchase',
    label: BillingFormattedMessages.purchaseMessages,
    accessLevel: '1',
    accessType: '1',
    customerType: 'B',
  },
];
